/* eslint-disable react/no-array-index-key */
import { Grid } from "@mui/material";
import { Box } from "@mui/system";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

import EditCompanyInfoModal from "components/Screens/SettingV2/EditCompanyInfoModal";

import UserAvatarIcon from "assets/svgs/UserAvatarIcon";

function DisplayCompanyInfo(props) {
  const {
    data,
    title,
    hanldeEdit,
    editAbleModal,
    handleCancel,
    handleSave,
    bgColor,
    handleInputChange,
    canEdit = true,
  } = props;

  const handleModalClose = () => {
    handleCancel(editAbleModal?.modalName, editAbleModal?.edit);
  };

  const onSaveClick = () => {
    handleSave(editAbleModal?.modalName, editAbleModal?.edit);
  };

  const renderInfoGrid = (infoData) => {
    const groupedFields = infoData.reduce((rows, item, index) => {
      if (index % 2 === 0) {
        rows.push([item]);
      } else {
        rows[rows.length - 1].push(item);
      }
      return rows;
    }, []);

    return groupedFields.map((fieldGroup, groupIndex) => (
      <div className="info-row" key={groupIndex}>
        {fieldGroup.map((infoItem, itemIndex) => (
          <div className="info-col" key={itemIndex}>
            <p className="heading-h5-regular text-headings-secondary">{infoItem.title}</p>
            <p className="para-body-m-medium">{infoItem.value}</p>
          </div>
        ))}
      </div>
    ));
  };

  return (
    <>
      <div className="company-info-top-section">
        <Grid sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Grid>
            {title === "Personal Information" && (
              <Box
                sx={{
                  display: "flex",
                  backgroundColor: bgColor,
                  borderRadius: "99px",
                  width: "42px",
                  height: "42px",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "9px",
                }}
              >
                <UserAvatarIcon color="#F9BD00" size="24" />
              </Box>
            )}
          </Grid>
          <p className="heading-h4-semibold">{title}</p>
        </Grid>

        {canEdit && (
          <EditOutlinedIcon
            disabled={!editAbleModal?.edit}
            className="profile-setting-edit-icon"
            onClick={() => hanldeEdit(title)}
          />
        )}
      </div>
      {/* info */}
      <Grid
        container
        direction="column"
        sx={{
          mt: 2,
          ml: 1,
          mr: 2,
        }}>
        {editAbleModal?.modalName === title && editAbleModal?.edit && (
          <Grid container direction="row" spacing={2} sx={{
            alignItems: "center"
          }}>
            <EditCompanyInfoModal
              title={title}
              editCompanyInfo={title === "Company Information"}
              open={editAbleModal?.modalName === title}
              handleModalClose={handleModalClose}
              handleSave={onSaveClick}
              data={data}
              handleInputChange={handleInputChange}
              canSave={canEdit}
            />
          </Grid>
        )}
        <div className="info-data-container">{renderInfoGrid(data)}</div>
      </Grid>
    </>
  );
}

export default DisplayCompanyInfo;
